import { Stack, styled, css } from '@mui/material';
import { IconButton } from '@engyalo/design-system';

export const MainStack = styled(Stack)(
  ({ theme }) => css`
    background: ${theme.palette.common.white};
    border-top: 1px solid ${theme.palette.neutral.var30};

    ${theme.breakpoints.down('md')} {
      width: -webkit-fill-available;
    }
  `
);

export const ActionsStack = styled(Stack)(
  () => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.4rem;
    padding: 0 0.4rem;

    &:first-of-type {
      padding-left: 0.8rem;
    }

    &:last-of-type {
      padding-right: 0.8rem;
    }
  `
);

export const ActionButton = styled(IconButton)(
  ({ theme, color }) => css`
    color: ${color === 'primary' ? theme.palette.primary.main : theme.palette.neutral.var60};
    font-size: 1.8rem;
  `
);

export const SendButton = styled(IconButton)(
  ({ theme }) => css`
    background-color: ${theme.palette.primary.main};
    color: ${theme.palette.common.white};
    border-radius: 50%;
  `
);
